import { AvailableThemes } from 'fe-lib-theme-types';
import { getSingleton, registerSingleton } from 'fe-lib-singleton';

const overrideThemeUniqueKey = Date.now().toString();
registerSingleton(overrideThemeUniqueKey, undefined);

export function overrideTheme(themeName: AvailableThemes): void {
  registerSingleton(overrideThemeUniqueKey, themeName);
}

export function getOverrideTheme(): AvailableThemes {
  return getSingleton(overrideThemeUniqueKey);
}
